// @flow

import { observer } from "mobx-react";
import React from "react";

import "./EditButton.scss";

type Props = {
    onClick: Function,
    text?: string
};

@observer
export default class EditButton extends React.Component<Props> {
    render() {
        const text = this.props.text || "Edit";

        return (
            <button
                type="button"
                className="EditButton"
                onClick={this.props.onClick}
            >
                <i className="fa fa-edit" /> {text}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/EditButton/EditButton.js